import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  duplicates: Set<string>;
}

export function VariableNameCollisionAlert({ name, duplicates }: Props) {
  const { t } = useTranslation();
  const normalized = name?.trim().toUpperCase();
  if (!normalized || !duplicates.has(normalized)) return null;

  return (
    <div className="flex items-start gap-2 p-2.5 bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-700 rounded-md text-xs text-amber-800 dark:text-amber-300">
      <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" />
      <span>
        {t(
          "variableCollision.warning",
          "Le nom « {{name}} » est déjà utilisé par une autre variable. Cela peut provoquer des conflits dans le code SILAE.",
          { name: normalized },
        )}
      </span>
    </div>
  );
}
